import React from "react";
import { FaDownload } from "react-icons/fa";
import "../../css/topcategories.css";
import gynaecology from "../../image/Gynaecology.webp";
import antibiotic from "../../image/Antibiotic.webp";
import orthopedic from "../../image/Orthopedic.webp";
import dermatology from "../../image/Dermatology.webp";
import cardiac from "../../image/Cardiac.webp";
import injectable from "../../image/Injectable.webp";



const ranges = [
  { title: "Gynaecology Range", img: gynaecology },
  { title: "Antibiotic Range", img: antibiotic },
  { title: "Orthopedic Range", img: orthopedic },
  { title: "Dermatology Range", img: dermatology },
  { title: "Cardiac & Diabetic Range", img: cardiac },
  { title: "Injectable Range", img: injectable },

];

function TopCategories({ setShowModal }) {
  const handleOpenModal = (range) => {
    // We open the global modal
    setShowModal(true);
  };

  return (
    <section className="py-3 py-lg-5" style={{ backgroundColor: "#fdfdfd" }} id="top">

      <div className="container">
        <div className="text-center mb-5">
          <div className="d-inline-flex align-items-center gap-2 mb-2">
            <div style={{ width: "40px", height: "3px", backgroundColor: "#e86229", borderRadius: "2px" }}></div>
            <h6 className="fw-bold text-uppercase mb-0" style={{ color: '#e86229', letterSpacing: '2px' }}>
              Our RANGES GALLERY
            </h6>
            <div style={{ width: "40px", height: "3px", backgroundColor: "#e86229", borderRadius: "2px" }}></div>
          </div>
          <h2 className="fw-bold display-5 top-category-heading" style={{ color: '#1a2f55', fontFamily: "'Georgia', serif" }}>
            Our Premium  Ranges
          </h2>
        </div>

        <div className="row g-4">
          {ranges.map((range, index) => (
            <div className="col-4" key={index}>
              <div className="range-card" onClick={() => handleOpenModal(range)}>
                <div className="image-wrapper">
                  <img src={range.img} alt={range.title} />
                </div>
                <div className="styled-footer">
                  <h3 className="range-title">{range.title}</h3>
                  <button className="btn-price-list">
                    Price List <FaDownload size={10} />
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
        <div className="download-btn-container mt-4 text-center">
          <button
            className="btn btn-danger btn-lg text-white fw-bold shadow-sm d-inline-flex align-items-center justify-content-center"
            style={{ borderRadius: '30px', padding: '12px 30px', backgroundColor: '#d32f2f', border: 'none', transition: 'all 0.3s ease' }}
            onClick={() => setShowModal(true)}
            onMouseEnter={(e) => { e.currentTarget.style.transform = 'scale(1.05)'; }}
            onMouseLeave={(e) => { e.currentTarget.style.transform = 'scale(1)'; }}
          >
            <FaDownload size={22} className="me-2" />
            Download Product List
          </button>
        </div>
      </div>

    </section>
  );
}

export default TopCategories;

